import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { dictionaryListcolDefs } from './dictionary-history-cols';
import { DataGrid } from '../../../components/data-grid/data-grid';
import { HTTPMethodType } from '../../../components/data-grid/data-grid-utils';
import { commonEnums } from '@codametrix/ui-common';
import { Box, Button, Flex } from '@chakra-ui/react';
import { AdminListPageLayout } from '../../../components/admin-list-page-layout/admin-list-page-layout';
import { BreadCrumbsComponent } from '../../../components/breadcrumbs/breadcrumbsComponent';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
const { FilterTypes } = commonEnums;
export const DictionaryHistory = (props)=>{
    const { downloadDictionaryByRequestID } = props;
    // get idDictionary for current dictionary on state
    const idDictionary = useSelector((state)=>{
        return state.dictionary.selectedDictionaryId;
    });
    const filterableOptions = {
        filters: [
            {
                key: 'dictionary_id',
                terms: [
                    idDictionary?.toString() ?? ''
                ],
                type: FilterTypes.EQ
            }
        ]
    };
    const endpoint = ()=>{
        const endPoint = {
            endPoint: `/dictionary/request/v2?`,
            HTTPMethodType: HTTPMethodType.POST
        };
        return endPoint;
    };
    const handleDownloadDictionary = (requestId)=>{
        downloadDictionaryByRequestID(requestId);
    };
    const updateColDefs = (columnDefs)=>{
        const cols = columnDefs.map((col)=>{
            let column = {
                ...col
            };
            if (col.headerName === 'Download') {
                column = {
                    ...column,
                    cellRenderer: (params)=>{
                        if (params.data.dictionaryCsvS3Uri && params.data.dictionaryCsvS3Uri.length > 0) {
                            return /*#__PURE__*/ _jsx(Button, {
                                variant: "link",
                                "data-dd-action-name": "~download dictionary",
                                onClick: ()=>handleDownloadDictionary(params.data.id),
                                children: /*#__PURE__*/ _jsx(BiomeIcon, {
                                    iconName: IconName.Download,
                                    titleText: "Download"
                                })
                            });
                        } else {
                            return '';
                        }
                    }
                };
            }
            return column;
        });
        return cols;
    };
    return /*#__PURE__*/ _jsxs(AdminListPageLayout, {
        children: [
            /*#__PURE__*/ _jsx(Flex, {
                flexShrink: 0,
                marginBottom: 5,
                children: /*#__PURE__*/ _jsx(BreadCrumbsComponent, {})
            }),
            /*#__PURE__*/ _jsx(Box, {
                flex: "1 1 0",
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                children: /*#__PURE__*/ _jsx(DataGrid, {
                    columnDefs: updateColDefs(dictionaryListcolDefs),
                    endpointData: endpoint(),
                    serverSideInfiniteScroll: true,
                    filterableOptions: filterableOptions,
                    paginationPageSize: 200
                })
            })
        ]
    });
};
export default DictionaryHistory;
